import NFTHeader from "@/components/NFTHeader";
import React, {useEffect, useRef, useState} from "react";
import Styles from './index.module.scss'
import ListView from "@/components/AntListView";
import appService from "@/utils/appService";
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import ExchangeModal from "@/view/supperzzle/components/exchangeModal";
import NFTModal from "@/components/NFTModal";
import {useNavigate} from "react-router-dom";
import Service from "@/view/supperzzle/service";
import JsBridgeNew from "@/utils/jsbridgeNew";
import qs from "query-string";

const ExchangeMall = () => {
  const [dataSource, setDataSource] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(20);
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [score, setScore] = useState(0)
  const { fromGems } = qs.parse(window.location.search);
  const handleNavigate = (uri) => {
    if(!uri) {
      return
    }
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` })
    } else {
      navigate(uri);
    }
  }
  const handleExchange = async (item) => {
    if(item.giftType === 8){
      await Service.getUserCertificateStatus()
    }
    const ModalInstance = NFTModal.show({
      content: <ExchangeModal
        data={item}
        score={score}
        onClose={() => ModalInstance?.close()}
        callBack={() => {
          loadData(true)
        }}
        navigate={navigate}
        fromGems={fromGems}
      />,
      getContainer: pageDom.current,
    });
  }
  const renderItem = (item) => {
    const disableBtn = !(item.goodsNum && score >= item.condition1)
    return (
      <div className={Styles.productBox}>
        <div className={Styles.picture}>
          <img src={item.imgUrl} alt=""/>
          {item?.condition2 && <div className={Styles.numTag}>限量 {item.condition2}</div>}
        </div>
        <div className={Styles.pointsLabel}>点数<span className={Styles.pointsValue}>{item?.condition1 || 0}</span></div>
        <div className={Styles.btnBox}>
          <button disabled={disableBtn} onClick={() => handleExchange(item)} className={disableBtn ? Styles.disableBtn : ''}>兑换</button>
        </div>
      </div>
    )
  }
  const loadData = async (isRefesh=false) => {
    try {
      isRefesh && showLoading();
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const res = await appService("600919",{
        activityCode: fromGems ? Service.activityCode2 : Service.activityCode,
        userCode: userInfo?.userCode
      }, false);
      isRefesh && hideLoading();
      console.log('res600919===>', res.data)
      setDataSource(res.data.pointLotteryList)
      setScore(res.data.score)
    } catch (error) {
      isRefesh && hideLoading();
      Toast.show(error);
    }
  }
  useEffect(() => {
    (()=>{
      loadData(true)
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      loadData(true)
      onDidFocus();
    });
  }
  const loadMore = async () => {
    currentPage.current += 1;
    await loadData(true)
  }
  return (
    <div className={Styles.mallPage} ref={pageDom}>
      <NFTHeader
        midText="兑换商城"
        bgColor="#FFFFFF"
        rightNode={() => <div className={Styles.recordBtn} onClick={() => {
          if(fromGems){
            handleNavigate('/supperzzle/exchangeRecord/?fromGems=true')
          } else {
            handleNavigate('/supperzzle/exchangeRecord')
          }
        }}>兑换记录</div>}
      />
      <div className={Styles.topBox}>
        <div className={Styles.pointsBox}>我的点数：{score}</div>
      </div>
      <div className={Styles.productContainer}>
        <ListView
          dataSource={dataSource}
          renderItem={renderItem}
          hasMore={hasMore}
          isLoad={true}
          onRefresh={()=>{
            currentPage.current = 1;
            loadData()
          }}
          style={{ display: 'flex', flexWrap: 'wrap'}}
          onEndReached={loadMore}
        />
      </div>
    </div>
  )
}
export default ExchangeMall